import { isSmallScreen } from "../../../helpers/screens";
import { Label, TextInput } from 'flowbite-react';
import { HiMail } from 'react-icons/hi';
import { useState } from "react";
import toast from 'react-hot-toast';

const SignupBoxSection = () => {
    const [email,setEmail] = useState("")
    const isSmall = isSmallScreen();
    const validateEmail = (ema:any) => {
        return ema.match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
      };
    const handleJoinClick = () => {
        if(validateEmail(email)) {
            window.location.href = `/book-a-demo?email=${email}`
        } else {
            toast.error("Email can not be null/empty !", {duration:1000});
        }
        
    }
    return (
        <div className={`relative isolate ${isSmall ? "" : " mt-10"}`} >
            <div className={`mx-auto px-36 xs:px-6 pb-24 xs:pb-6 xs:!pt-12 relative  `} >
                <div className="text-center relative" >
                    <div className="mb-4  text-center relative">
                        <span className="text-center text-white text-4xl xs:text-xl font-semibold xs:font-extrabold font-['Work Sans''] mb-2">Supercharge your project planning with </span>
                        <span className="text-white text-4xl xs:text-xl font-semibold xs:font-extrabold font-['Inter'] mb-2">Cadence<span className="">pro</span><span className="">.ai</span></span>
                        
                        <div className="w-96 h-64 top-12 right-[30%] mx-auto z-[-1] absolute origin-top-left rotate-[-15deg] opacity-40 bg-gradient-to-tr from-blue-700 via-indigo-800 to-blue-700 rounded-2xl blur-3xl" />
                    </div>
                    <div className="text-center text-gray-400 text-xl xs:text-sm font-normal font-['Inter'] mb-1 max-w-[768px] mx-auto">Step into the future of productivity with Cadencepro.ai - power your projects with interactive AI and match your targets with the best plans in action. </div>
                    <div className="mt-10 xs:mt-5 flex items-center justify-center gap-x-6 relative">
                    <div className="flex xs:mb-10">
                        <TextInput  theme= {{field:{input:{base:" rounded-none rounded-tl-3xl rounded-bl-3xl w-96 xs:w-48"}}}} type="email" className="!rounded-none" icon={HiMail} placeholder="Enter your Email" required onChange={(e)=>setEmail(e.target.value)} />
                        <button onClick={handleJoinClick} className="w-40 xs:w-26 rounded-none rounded-tr-3xl rounded-br-3xl bg-blue-600 px-3.5 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 cursor-pointer">
                            <div className="text-white text-base xs:text-xs font-medium font-['Inter']">Get early access</div>
                        </button>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SignupBoxSection;